// extracted by mini-css-extract-plugin
module.exports = {"content":"wrapper_content__3T1wN","content__scroll":"wrapper_content__scroll__3H9mE"};